import { apiUrls } from '../plugins/apiUrls';
export default function (value) {
    return `${apiUrls.IMAGEN}?path=${value}&m=1`
}
